import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import install from './components/index'
import "./style/reset.css"
import "./style/common.css"
import "./assets/font/iconfont.css"
import 'nprogress/nprogress.css'
Vue.use(ElementUi)
Vue.use(install)
Vue.config.productionTip = false

// import './mock/index'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')